import { Inject, Injectable, InjectionToken, ValueProvider } from '@angular/core';

export interface GlobalAppConfig {
  loadingTimeout: number;
  maxPdoOffersCount: number;
  offersCacheLifetimeMinutes: number;
  tempSuspensionMinRemainingDays: number;
  vaEnvironment: string;
}

export const GLOBAL_APP_CONFIG = new InjectionToken<GlobalAppConfig>('GlobalAppConfig');

@Injectable()
export class GlobalAppConfigService {
  static configure(config?: GlobalAppConfig): ValueProvider {
    return {
      provide: GLOBAL_APP_CONFIG,
      useValue: config || {},
    };
  }

  constructor(@Inject(GLOBAL_APP_CONFIG) public config: GlobalAppConfig) {}
}
